import { SmartDataLogo } from '@ctek/design-system';
import { AssignmentKind } from 'century-core/core-apis/assignment/types';

export const SmartAssignmentIcon = ({ kind }: { kind: AssignmentKind }) => (kind === 'Smart' ? <SmartDataLogo /> : null);
